export enum ConversationRole {
  model = 'model',
  user = 'user'
}
